package com.parmartechnologies.core.feature.auth.network

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SendOTPRequest(
    @SerialName("mobile_number") val mobile_number: String,
    @SerialName("dial_code") val dial_code: String
)

@Serializable
data class CheckAccountRequest(
    @SerialName("mobile_number") val mobile: String,
    @SerialName("dial_code") val dial_code: String,
    @SerialName("name") val name: String
)

@Serializable
data class GetUserRequest(
    @SerialName("_id") val _id: String,
)

@Serializable
data class SetPasswordRequest(
    @SerialName("_id") val _id: String,
    @SerialName("password") val password: String,
)

@Serializable
data class AuthRequest(
    @SerialName("mobile_number") val mobile_number: String,
    @SerialName("dial_code") val dial_code: String,
    @SerialName("name") val name: String
)

@Serializable
data class UpdateFCMTokenRequest(
    @SerialName("user_id") val user_id: String,
    @SerialName("fcm_token") val token: String,
    @SerialName("device_id") val device_id: String
)

@Serializable
data class LanguageRequest(
    @SerialName("code") val code: String,
)